import { render, staticRenderFns } from "./CompetencesCles.vue?vue&type=template&id=864892ce&"
import script from "./CompetencesCles.vue?vue&type=script&lang=js&"
export * from "./CompetencesCles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports